/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpIcon20Light = forwardRef('ArrowAUpIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.291 8.635a.5.5 0 1 1-.707-.707L7.82 2.69a2.375 2.375 0 0 1 3.358 0l5.237 5.237a.5.5 0 0 1-.707.707l-5.237-5.237A1.371 1.371 0 0 0 10 3.09V17.5a.5.5 0 1 1-1 0V3.09a1.37 1.37 0 0 0-.472.308L3.29 8.635Z" })));
});
